import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreatePlanSubscriptionDTO, DeactivatePlanSubscriptionDTO } from "../models/PlanSubscription/planSubscription.request";
import { LocalPlanSubscriptionInfoDTO } from "../models/PlanSubscription/planSubscription.response";


export const planSubscriptionService = {

    async create(dto: CreatePlanSubscriptionDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>('/plansubscriptions', dto);
        return data;
    },

    async cancel(id: string, dto: DeactivatePlanSubscriptionDTO): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/plansubscriptions/${id}/cancel`, dto);
        return data;
    },

    async paymentConfirmNotify(id: string, localId: string): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/plansubscriptions/payment-confirm`, null, {
            params: {
                localId,
                id,
            }
        });
        return data;
    },

    async getLocalPlanSubscriptionInfo(localId: string): Promise<ApiResponse<LocalPlanSubscriptionInfoDTO>> {
        const { data } = await api.get<ApiResponse<LocalPlanSubscriptionInfoDTO>>(`locals/${localId}/plans-subscriptions/info`);
        return data;
    }

};